import React from "react";
import classNames from "classnames";
import styles from "./Settings.module.scss";

export default function SettingsForm({ children, className }) {
  return <div className={classNames(styles.settingsForm, className)}>{children}</div>;
}
